module.exports = __webpack_public_path__ + "img/ticketBg.072be91f.jpg";